
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { DTO_WriteCategoryDto, DTO_WriteCategoryDto_$reflection } from "../../Shared/Category.js";
import { union_type, class_type, string_type, record_type, lambda_type, unit_type, bool_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState_get_empty, FormState__setValidationResponse_5219762A, FormState__startLoading, ClientApiResponse$1_$reflection, FormState_$reflection } from "../../Shared/Shared.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Input } from "../../Components/Input.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Badge } from "../../Components/Badge.js";
import { TextButton, Button } from "../../Components/Button.js";
import { ColorPicker_colorPicker_BD3CF72 } from "../../SharedComponents/ReactColorPicker.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { ErrorAlert, InformationAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";

class State extends Record {
    constructor(CategoryForm, IsLabelColorSelectorOpen, FormState, OnClose) {
        super();
        this.CategoryForm = CategoryForm;
        this.IsLabelColorSelectorOpen = IsLabelColorSelectorOpen;
        this.FormState = FormState;
        this.OnClose = OnClose;
    }
}

function State_$reflection() {
    return record_type("Widgets.Dialogs.NewCategoryDialog.State", [], State, () => [["CategoryForm", DTO_WriteCategoryDto_$reflection()], ["IsLabelColorSelectorOpen", bool_type], ["FormState", FormState_$reflection()], ["OnClose", lambda_type(unit_type, unit_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetName", "SetColorHex", "SetVisibleForUser", "SaveCategory", "ToggleColorSelector", "CategorySaved", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Dialogs.NewCategoryDialog.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function update(msg, state) {
    let bind$0040_1, bind$0040_2, bind$0040;
    switch (msg.tag) {
        case 1:
            return [new State((bind$0040_1 = state.CategoryForm, new DTO_WriteCategoryDto(bind$0040_1.Name, msg.fields[0], bind$0040_1.VisibleForUserRole, bind$0040_1.ParentLabelId)), state.IsLabelColorSelectorOpen, state.FormState, state.OnClose), Cmd_none()];
        case 2:
            return [new State((bind$0040_2 = state.CategoryForm, new DTO_WriteCategoryDto(bind$0040_2.Name, bind$0040_2.ColorHex, msg.fields[0], bind$0040_2.ParentLabelId)), state.IsLabelColorSelectorOpen, state.FormState, state.OnClose), Cmd_none()];
        case 3:
            return [new State(state.CategoryForm, state.IsLabelColorSelectorOpen, FormState__startLoading(state.FormState), state.OnClose), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/categories", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_WriteCategoryDto_$reflection(), undefined, undefined, undefined)(state.CategoryForm))], (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(6, [Item_1])))];
        case 4:
            return [new State(state.CategoryForm, !state.IsLabelColorSelectorOpen, state.FormState, state.OnClose), Cmd_none()];
        case 5: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.CategoryForm, state.IsLabelColorSelectorOpen, FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.OnClose), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.CategoryForm, state.IsLabelColorSelectorOpen, FormState_get_empty(), state.OnClose), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg) => {
                    state.OnClose();
                })]))];
            }
        }
        case 6:
            return [new State(state.CategoryForm, state.IsLabelColorSelectorOpen, FormState_get_empty(), state.OnClose), Cmd_none()];
        default:
            return [new State((bind$0040 = state.CategoryForm, new DTO_WriteCategoryDto(msg.fields[0], bind$0040.ColorHex, bind$0040.VisibleForUserRole, bind$0040.ParentLabelId)), state.IsLabelColorSelectorOpen, state.FormState, state.OnClose), Cmd_none()];
    }
}

function init(onClose) {
    return [new State(new DTO_WriteCategoryDto("", "#9A9FFF", true, undefined), false, FormState_get_empty(), onClose), Cmd_none()];
}

function LabelForm(props) {
    let elems_4;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-xl", "flex", "flex-col", "gap-5"])], (elems_4 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(Input, {
            ComponentState: componentState,
            Label: t("category.name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(0, [arg]));
            },
            TestId: "new-category-name-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.Label.Name,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(Badge, {
                Color: props.Label.ColorHex,
                Label: "",
                TestId: "new-category-test-id",
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_3;
                return append(singleton(reactElement("div", createObj(ofArray([["className", "form-group"], (elems_3 = toList(delay(() => {
                    let elems_2;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems_2 = [createElement(Button, {
                        ComponentState: componentState,
                        Label: t("category.choose_color"),
                        OnClick: () => {
                            props.Dispatch(new Msg(4, []));
                        },
                        TestId: "settings-choosecolor-button",
                        Variant: "secondary",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => ((props.IsColorSelectorOpen && !props.FormState.IsLoading) ? singleton(ColorPicker_colorPicker_BD3CF72((color) => {
                        props.Dispatch(new Msg(1, [color.hex]));
                    }, props.Label.ColorHex)) : empty())));
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => append(singleton(Checkbox({
                    ComponentState: componentState,
                    IsChecked: props.Label.VisibleForUserRole,
                    Label: t("category.visible_for_user"),
                    OnCheck: (arg_1) => {
                        props.Dispatch(new Msg(2, [arg_1]));
                    },
                    TestId: "category-visible-for-user-checkbox",
                })), delay(() => append(singleton(createElement(InformationAlert, {
                    Label: t("category.visible_for_user_tooltip"),
                })), delay(() => {
                    const matchValue = FormState__getValidation(props.FormState, t, "global");
                    if (matchValue == null) {
                        return empty();
                    }
                    else {
                        return singleton(createElement(ErrorAlert, {
                            Label: matchValue,
                        }));
                    }
                }))))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function NewCategoryDialog(props) {
    let Title;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("settings.create_new_label"), {
        Body: singleton_1(createElement(LabelForm, {
            Dispatch: dispatch,
            FormState: state_1.FormState,
            IsColorSelectorOpen: state_1.IsLabelColorSelectorOpen,
            Label: state_1.CategoryForm,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-qr-code-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(3, []));
            },
            TestId: "close-qr-code-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

